/**
 * Component: Collection Render
 * ------------------------------------------------------------------------------
 * - The entry component for the legacy PLP.
 * - Duplicate of `SearchRender.js`
 * @namespace CollectionRender
 */
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import store from '~/components/vue/store/index'

import collectionRender from '~legacy-vue/CollectionPageContainer.vue'

/**
 * Create a new CollectionRender
 */
export default () => {

  /**
   * Initialise component.
   */
  function init() {
    const app = createApp(collectionRender)

    app.use(store)
    app.use(createPinia())

    app.mount('#CollectionRender')
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
